import ApplicationController from '../application_controller';

function actualizarCuentasSelect(bancoId, cuentasSelect, ev) {
  cuentasSelect.find('option').remove();
  cuentasSelect.prepend($('<option value="">Seleccionar</option>'));
  if (bancoId !== '') {
    // gestion_economica/centros_bancos/:centros_banco_id/cuentas(.:format)
    $.get(`/gestion_economica/centros_bancos/${bancoId}/cuentas`, (response) => {
      $(response).each((key, cuenta) => {
        cuentasSelect.append($(`<option value="${cuenta[1]}">${cuenta[0]}</option>`));
      });
    });
  }
  ev.stopPropagation();
  ev.preventDefault();
}

/* global $ */
export default class extends ApplicationController {
  connect() {
    this.$element = $(this.element);
    this.$element.on('click', '#guarda_contrato', () => {
      // Al hacer click en guardar oculto el area que estaba desplegada
      const $elemento = $('#CrearContrato');
      $elemento.attr('aria-expanded', 'false');
      $elemento.toggleClass('in');
    }).on('change', '.gestion_economica_centro_banco_banco_id select', (e) => {
      const $select = $(e.currentTarget);
      // Actualizamos las cuentas en funcion del banco seleccionado (creacion y listado)
      actualizarCuentasSelect(
        $select.val(),
        $select.closest('.contratos-remesas').find('.gestion_economica_centro_banco_cuenta_id select'),
        e,
      );
    }).on('change', '.filtro_centro_banco_banco_id select', (e) => {
      const $select = $(e.currentTarget);
      // Actualizamos las cuentas en funcion del banco seleccionado (filtros)
      actualizarCuentasSelect(
        $select.val(),
        $select.closest('.contratos-remesas').find('.filtro_centro_banco_cuenta_id select'),
        e,
      );
    });
  }
}
